<template>
  <div class="home-menu-component-df">
    <div class="mian">
      <div class="wrap">
        <ul class="menulist">
          <li class="menuItem" v-for="(item, idx) in dflotteryTypes" :key="idx" @click="getLotteryList(idx)"
            :class="idx == lotteryTpeIdx ? 'on' : ''">
            {{ item.lotteryTypeName }}</li>
        </ul>
      </div>
    </div>
    <div class="banner-container">
      <img src="../../assets/banner.png" alt="" class="banner">
    </div>
    <div class="home-lottery-component-list">
      <openLottery :list="lotteryLatelyLpVo" :cdn="'https://qny-zhzy.mcjdzsw.top/'" :type="dflotteryTypes[lotteryTpeIdx].lotteryTypeCode">
      </openLottery>
    </div>
  </div>
</template>

<script>
import mix from "~/mixins/home.mixins.vue";
import openLottery from '~/components/openLottery.vue';
export default {
  mixins: [mix],
  components: {
    openLottery
  },
  data() {
    return {
      lotteryTpeIdx: 0,
      // dflotteryTypes: [
      //   {
      //     "lotteryTypeCode": "all",
      //     "lotteryTypeName": "全部彩种"
      //   },
      //   {
      //     "lotteryTypeName": "大乐透",
      //     "lotteryTypeCode": "DLT"
      //   },
      //   {
      //     "lotteryTypeName": "时时彩",
      //     "lotteryTypeCode": "SSC"
      //   },
      //   {
      //     "lotteryTypeName": "六合彩",
      //     "lotteryTypeCode": "LHC"
      //   },
      //   {
      //     "lotteryTypeName": "3D",
      //     "lotteryTypeCode": "3D"
      //   },
      //   {
      //     "lotteryTypeName": "排列三",
      //     "lotteryTypeCode": "PL3"
      //   },
      //   {
      //     "lotteryTypeName": "PC蛋蛋",
      //     "lotteryTypeCode": "PCDD"
      //   },
      //   {
      //     "lotteryTypeName": "双色球",
      //     "lotteryTypeCode": "SSQ"
      //   },
      //   {
      //     "lotteryTypeName": "PK拾",
      //     "lotteryTypeCode": "PK10"
      //   },
      //   {
      //     "lotteryTypeName": "快三",
      //     "lotteryTypeCode": "K3"
      //   },
      //   {
      //     "lotteryTypeName": "11选5",
      //     "lotteryTypeCode": "11X5"
      //   },
      //   {
      //     "lotteryTypeName": "指数",
      //     "lotteryTypeCode": "ZHISHU"
      //   }
      // ]
    };
  },
  mounted() {
  },
  computed: {
    // 大发彩票类型列表
    dflotteryTypes() {
      let list = [{
        lotteryTypeName: "全部彩种",
        lotteryTypeCode: "all"
      }]
      this.$store.state.lottery.lotteryTypes.forEach((item) => {
        if (item.lotteryTypeName) {
          list.push({
            lotteryTypeName: item.lotteryTypeName,
            lotteryTypeCode: item.lotteryTypeCode
          })
        }
      })

      return list
    },
  },
  methods: {
    getLotteryList(num) {
      this.lotteryTpeIdx = num
    }
  }
};
</script>

<style lang="less">
body {
  -webkit-overflow-scrolling: touch;
  background-color: #e5e5e5;
  background-image: url('../../assets/dfbg.png');
  background-repeat: no-repeat;
  background-size: 134vw;
  background-position-x: center;
  background-attachment: fixed;
}

.home-menu-component-df {
  box-shadow: 0 2px 12px rgba(0, 0, 0, .08);
  width: 100%;
  font-size: 16px;
  color: #333;

  .mian {
    background: #fff;
  }

  .wrap {
    width: 1200px;
    height: 50px;
    margin: 0 auto;

    .menulist {
      display: flex;
      align-items: center;
      height: 50px;
      font-size: 16px;
    }

    .menuItem {
      width: 64px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      color: #666;
      cursor: pointer;
      position: relative;
      font-size: 16px;
    }

    .menulist li+li {
      margin-left: 18px
    }

    .menuItem.on,
    .menuItem:hover {
      color: #ec5141
    }

    .menuItem.on:after {
      content: "";
      display: inline-block;
      width: 100%;
      height: 4px;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: #ec5141
    }
  }

  .banner-container {
    width: 1200px;
    background-image: url(data:image/png;base64,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);
    background-repeat: no-repeat;
    background-size: contain;
    background-position-y: 200px;
    margin: 0 auto;
    padding: 20px 0;

    .banner {
      height: 180px;
      display: flex;
    }
  }

  .home-lottery-component-list {
    margin: 0 auto;
    width: 1200px;
    overflow: hidden;

    .home-lottery-component {
      margin-bottom: 20px;
      background: #fff;

      .lottery-component {
        margin-bottom: 20px;
        background: #fff;

        .lottery-container {
          width: 1200px;
          height: 160px;
          border: 1px solid #e0e0e0;
          box-shadow: 0 4px 6px rgba(0, 0, 0, .04);
          display: flex;
          color: #333;
          font-size: 16px;
          position: relative;

          .lottery-info {
            width: 215px;
            border-left-width: 6px;
            border-left-style: solid;
            padding: 15px 0;
            flex-direction: column
          }

          .lottery-name {
            font-weight: 500;
            font-size: 22px;
            position: relative;
            z-index: 1;
            margin-bottom: 8px
          }

          .lottery-icon {
            width: 100px;
            height: 100px;
            overflow: hidden;

            img {
              width: 80px;
              -webkit-box-reflect: below -5px -webkit-linear-gradient(top, rgba(250, 250, 250, 0.3), rgba(250, 250, 250, 0.3) 30%, rgba(250, 250, 250, 0));
              box-reflect: below -5px linear-gradient(top, rgba(250, 250, 250, 0.3), rgba(250, 250, 250, 0.3) 30%, rgba(250, 250, 250, 0));
            }
          }

          .lottery-result {
            width: 527px;
            padding: 14px 30px;
            box-sizing: border-box;
          }

          .results ul li {
            display: inline-flex;
            justify-content: center;
            align-items: center;
          }

          .issue-title>span:first-child {
            margin-right: 16px
          }

          .issue-title>span:last-child:not(:first-child) {
            margin: 0 10px;
          }

          .text-focus {
            color: red;
          }

          .lottery-name:after {
            content: "";
            width: 90%;
            height: 14px;
            position: absolute;
            bottom: 0;
            right: 0;
            z-index: -1
          }

          .home-lottery-component .lottery-container>div.border-left {
            margin: 15px 0;
            border-left: 1px dashed #dbdbdb;
          }
        }
      }

      .lottery-component.SSC {
        background: linear-gradient(90deg, #fff7f0 .5%, rgba(255, 250, 248, 0) 22.2229%)
      }

      .lottery-container>div:first-child {
        display: flex;
        justify-content: center;
        align-items: center
      }

      .lottery-container .lottery-open {
        width: 280px;
        padding: 14px 0 0 38px;
        box-sizing: border-box;
      }

      .lottery-container .lottery-more button+button {
        margin-top: 20px
      }

      .lottery-container .lottery-more .btn {
        width: 118px;
        height: 38px;
        text-decoration: none;
        color: #4973df;
        border: 1px solid #4973df;
        border-radius: 2px;
        background-color: #fff;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          margin-right: 5px;
          font-style: normal;
        }
      }

      .lottery-container .lottery-more .btn:active,
      .lottery-container .lottery-more .btn:hover {
        color: #fff;
        background: linear-gradient(180deg, #657cf3, #4c6bdb 118.06%)
      }

      .lottery-container .lottery-more {
        width: 191px;
        flex-direction: column;
        box-sizing: border-box;
      }

      .lottery-container .lottery-open .time-count>div {
        width: 56px;
        height: 48px;
        border-radius: 2px;
        background: linear-gradient(180deg, #717171, #4a4a49);
        color: #fff;
        font-size: 30px;
        line-height: 48px;
        text-align: center;
        margin-right: 14px
      }

      .lottery-open .time-count {
        padding-top: 29px;
        display: inline-flex;
        align-items: center;
      }

      .lottery-container>div:nth-child(4n) {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-right: 40px
      }

      .lottery-container>div.border-left {
        margin: 15px 0;
        border-left: 1px dashed #dbdbdb
      }

      .lottery-container.DF_SSC {
        background: linear-gradient(90deg, #fff7f0 .5%, rgba(255, 250, 248, 0) 22.2229%);
      }

      .lottery-container.DF_SSC .lottery-info {
        border-left-color: #fc8d26
      }

      .lottery-container.DF_SSC .lottery-info .lottery-name:after {
        background-color: #ffe7d1
      }

      .lottery-container.DF_K3 {
        background: linear-gradient(90deg, #fff5f5 .5%, rgba(255, 249, 248, 0) 22.2229%)
      }

      .lottery-container.DF_K3 .lottery-info {
        border-left-color: #e41404
      }

      .lottery-container.DF_K3 .lottery-info .lottery-name:after {
        background-color: #ffdbdb
      }

      .lottery-container.DF_ZHISHU {
        background: linear-gradient(90deg, #fff6fb .5%, rgba(255, 250, 248, 0) 22.2229%);
      }

      .lottery-container.DF_ZHISHU .lottery-info {
        border-left-color: #f43000
      }

      .lottery-container.DF_ZHISHU .lottery-info .lottery-name:after {
        background-color: #ffc7b9
      }

      .lottery-container.DF_DLT {
        background: linear-gradient(90deg, #fff5f5 .5%, rgba(255, 249, 248, 0) 22.2229%)
      }

      .lottery-container.DF_DLT .lottery-info {
        border-left-color: #fb25f5
      }

      .lottery-container.DF_DLT .lottery-info .lottery-name:after {
        background-color: #fee3ff
      }

      .lottery-container.DF_PK10 {
        background: linear-gradient(90deg, #fff6fb .5%, hsla(0, 100%, 98%, 0) 22.2229%)
      }

      .lottery-container.DF_PK10 .lottery-info {
        border-left-color: #f22751
      }

      .lottery-container.DF_PK10 .lottery-info .lottery-name:after {
        background-color: #ffdbf0
      }

      .lottery-container.DF_PCDD {
        background: linear-gradient(90deg, #fff5f5 .5%, rgba(255, 249, 248, 0) 22.2229%)
      }

      .lottery-container.DF_PCDD .lottery-info {
        border-left-color: #00c5ef
      }

      .lottery-container.DF_PCDD .lottery-info .lottery-name:after {
        background-color: #c4f5ff
      }

      .lottery-container.DF_SSQ {
        background: linear-gradient(90deg, #fff6fb .5%, hsla(0, 100%, 98%, 0) 22.2229%)
      }

      .lottery-container.DF_SSQ .lottery-info {
        border-left-color: #4962ff
      }

      .lottery-container.DF_SSQ .lottery-info .lottery-name:after {
        background-color: #cbd3ff
      }

      .lottery-container.DF_LHC {
        background: linear-gradient(90deg, #f7fffc .5%, rgba(249, 255, 253, 0) 22.2229%)
      }

      .lottery-container.DF_LHC .lottery-info {
        border-left-color: #07b39e
      }

      .lottery-container.DF_LHC .lottery-info .lottery-name:after {
        background-color: #c7f4e1
      }

      .lottery-container.DF_11X5 {
        background: linear-gradient(90deg, #f7fcff .5%, rgba(247, 253, 255, 0) 22.2229%)
      }

      .lottery-container.DF_11X5 .lottery-info {
        border-left-color: #2192dd
      }

      .lottery-container.DF_11X5 .lottery-info .lottery-name:after {
        background-color: #d3efff
      }

      .lottery-container.DF_3D {
        background: linear-gradient(90deg, #f7fbff .5%, rgba(247, 255, 255, 0) 22.2229%)
      }

      .lottery-container.DF_3D .lottery-info {
        border-left-color: #41c3ec
      }

      .lottery-container.DF_3D .lottery-info .lottery-name:after {
        background-color: #cbf2f4
      }

      .lottery-container.DF_PL3 {
        background: linear-gradient(90deg, #f9fff7 .5%, rgba(249, 255, 247, 0) 22.2229%)
      }

      .lottery-container.DF_PL3 .lottery-info {
        border-left-color: #38b366
      }

      .lottery-container.DF_PL3 .lottery-info .lottery-name:after {
        background-color: #d3f1c5
      }
    }
  }
}
</style>